import React, { useState } from 'react';
import { Box, Heading, VStack, Text, Button, Input, HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiTrendingUp } from 'react-icons/fi';
import {useAppData} from '../../store/dataStore';

const MotionBox = motion(Box);

const popularArticles = [
  { id: 1, title: "How Will AI Affect the Global Workforce in 2025?", views: "12.5K" },
  { id: 2, title: "Getting Ready for the AI World", views: "9.8K" },
  { id: 3, title: "5 GenAI Projects to Build This Weekend", views: "8.2K" },
  { id: 4, title: "From Marketing to AI Developer", views: "7.5K" },
  { id: 5, title: "2026 Job Outlook: Which AI Roles Will Boom?", views: "6.9K" }
];

const categories = [
  "Getting Started with AI",
  "Career Advice",
  "Industry News"
];

const BlogSidebar = ({ setSelectedCategory }) => {
  const { appData } = useAppData();
  const { studentsCount } = appData;
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // GA: newsletter_signup
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <VStack spacing={6} align="stretch">
      {/* Categories */}
      <MotionBox
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        bg="white"
        p={6}
        borderRadius="xl"
        boxShadow="md"
      >
        <Heading size="md" mb={4} color="brand.800" fontFamily="heading">
          Categories
        </Heading>
        <VStack align="stretch" spacing={2}>
          {categories.map((category) => (
            <Button
              key={category}
              variant="ghost"
              justifyContent="flex-start"
              color="brand.600"
              _hover={{ bg: 'brand.50', color: 'accent.green' }}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </Button>
          ))}
        </VStack>
      </MotionBox>

      {/* Popular Articles */}
      <MotionBox
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        bg="white"
        p={6}
        borderRadius="xl"
        boxShadow="md"
      >
        <HStack mb={4}>
          <FiTrendingUp color="#10B981" />
          <Heading size="md" color="brand.800" fontFamily="heading">
            Popular Articles
          </Heading>
        </HStack>
        <VStack align="stretch" spacing={3}>
          {popularArticles.map((article, index) => (
            <Box
              key={article.id}
              p={3}
              borderRadius="md"
              _hover={{ bg: 'brand.50', cursor: 'pointer' }}
              transition="all 0.2s"
            >
              <HStack justify="space-between" mb={1}>
                <Text fontSize="xs" color="accent.green" fontWeight="600">
                  #{index + 1}
                </Text>
                <Text fontSize="xs" color="brand.400">
                  {article.views} views
                </Text>
              </HStack>
              <Text fontSize="sm" color="brand.700" fontWeight="500">
                {article.title}
              </Text>
            </Box>
          ))}
        </VStack>
      </MotionBox>

      {/* Newsletter Signup */}
      <MotionBox
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        bg="brand.700"
        color="white"
        p={6}
        borderRadius="xl"
        boxShadow="md"
      >
        <Heading size="md" mb={2} fontFamily="heading">
          Get AI insights weekly
        </Heading>
        <Text fontSize="sm" mb={4} opacity={0.9}>
          Stay updated with the latest trends.
        </Text>
        <form onSubmit={handleNewsletterSubmit}>
          <VStack spacing={3}>
            <Input
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              bg="white"
              color="brand.800"
              size="md"
              required
            />
            <Button
              type="submit"
              variant="solid"
              w="full"
              bg="accent.gold"
              color="brand.800"
              _hover={{ bg: 'accent.green' }}
            >
              Subscribe
            </Button>
          </VStack>
        </form>
      </MotionBox>
    </VStack>
  );
};

export default BlogSidebar;
